import { z } from 'zod';

/**
 * NormalizedError (§8.2). Connectors and the runtime translate provider-specific
 * failures into this one shape so the platform's retry/ambiguity logic (I8/§9.4)
 * is provider-agnostic.
 */
export const normalizedError = z.object({
  /** Stable platform error code, e.g. 'connection.expired', 'rate_limited'. */
  code: z.string().min(1),
  /** Whether the platform may retry an idempotent operation after this error. */
  retryable: z.boolean(),
  /** Raw provider code, preserved for diagnostics (never used for control flow). */
  providerCode: z.string().optional(),
  /** Human-readable, safe-to-log message (never contains secrets — I6). */
  message: z.string(),
});
export type NormalizedError = z.infer<typeof normalizedError>;
